import { TRANSLATOR_ACTIONS } from 'constants/Actions/Translator';
import { LANGUAGES } from 'constants/Languages';

// Estado inicial del reducer
const aInitialState = {
    sLanguage: LANGUAGES.PORTUGUESE,
    bChange: false,
}
/**
 * Reducer que sera utilizado para controlar las variables globales referidas a la traduccion
 * 
 * @param {Array} oState Estado, si no recibe datos se setea el estado inicial
 * @param {object} oAction Action que es ejecutada
 * 
 * @returns {Array} Retorna un array que sera seteado en el estado del reducer
 * 
 * @author Leandro Curbelo 
 */
export const TranslatorReducer = (oState = aInitialState, oAction) => {
    switch (oAction.type) {
        case TRANSLATOR_ACTIONS.GET:
            return { ...oState, sLanguage: oAction.data, bChange: true };
        case TRANSLATOR_ACTIONS.CLEAN:
            return { ...oState, bChange: false };
        default:
            return oState;
    }
}
